export const PartialStockUpdateEnums = {
    Default : 0,
    UpdatePartialStock :1,
    NoUpdate :2
};
